export default __webpack_public_path__ + "static/outsource@768_2x-fe6821e63f1b07c48f446c3967ed4925.png";